module.exports = __webpack_public_path__ + "apple.svg";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/button/assets/apple.svg
// module id = 1064
// module chunks = 10